import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Form, Input, Radio, Spin } from "antd";
import { observer } from "mobx-react";
import moment from "moment";
import { useCallback, useState } from "react";
import { __ } from "../../../utils/i18n.js";
import { urlBuilder } from "../../../utils/request.js";
import { locationRestExportConsentsGet } from "../../../wp-api/exportConsents.get.js";
import { DateRangePicker } from "../../dateRangePicker.js";
const LAYOUT = {
    labelCol: {
        span: 24
    },
    wrapperCol: {
        span: 24
    }
};
const ExportConsentsForm = observer(()=>{
    const [form] = Form.useForm();
    const [isBusy, setBusy] = useState(false);
    const [showSizeHint, setShowSizeHint] = useState(false);
    const initialValues = {
        by: "",
        date: [],
        uuid: ""
    };
    // Download export as CSV
    const handleDownloadButton = useCallback(()=>{
        (async ()=>{
            setBusy(true);
            setShowSizeHint(true);
            const { uuid, date } = form.getFieldsValue();
            const url = urlBuilder({
                location: locationRestExportConsentsGet,
                params: {
                    uuid: uuid || "",
                    from: date?.[0].format("YYYY-MM-DD") || "",
                    to: date?.[1].format("YYYY-MM-DD") || ""
                }
            });
            window.open(url, "_blank");
            setBusy(false);
        })();
    }, [
        setBusy,
        setShowSizeHint,
        form
    ]);
    return /*#__PURE__*/ _jsx(Spin, {
        spinning: isBusy,
        children: /*#__PURE__*/ _jsxs(Form, {
            name: "export",
            form: form,
            ...LAYOUT,
            initialValues: initialValues,
            onFinish: handleDownloadButton,
            labelWrap: true,
            children: [
                /*#__PURE__*/ _jsx(Form.Item, {
                    label: __("Export by"),
                    required: true,
                    children: /*#__PURE__*/ _jsx(Form.Item, {
                        name: "by",
                        noStyle: true,
                        rules: [
                            {
                                required: true,
                                message: __("Please select an option!")
                            }
                        ],
                        children: /*#__PURE__*/ _jsxs(Radio.Group, {
                            children: [
                                /*#__PURE__*/ _jsx(Radio.Button, {
                                    value: "date",
                                    children: __("Date range")
                                }),
                                /*#__PURE__*/ _jsx(Radio.Button, {
                                    value: "uuid",
                                    children: __("UUID")
                                })
                            ]
                        })
                    })
                }),
                /*#__PURE__*/ _jsx(Form.Item, {
                    noStyle: true,
                    shouldUpdate: (prevValues, nextValues)=>prevValues.by !== nextValues.by,
                    children: ({ getFieldValue })=>getFieldValue("by") === "date" && /*#__PURE__*/ _jsx(Form.Item, {
                            name: "date",
                            label: __("Date range"),
                            required: true,
                            rules: [
                                {
                                    type: "array",
                                    required: true,
                                    message: __("Please provide a valid date range!")
                                }
                            ],
                            children: /*#__PURE__*/ _jsx(DateRangePicker, {
                                disabledDate: (d)=>!d || d.isAfter(moment())
                            })
                        })
                }),
                /*#__PURE__*/ _jsx(Form.Item, {
                    noStyle: true,
                    shouldUpdate: (prevValues, nextValues)=>prevValues.by !== nextValues.by,
                    children: ({ getFieldValue })=>getFieldValue("by") === "uuid" && /*#__PURE__*/ _jsx(Form.Item, {
                            name: "uuid",
                            label: __("UUID"),
                            required: true,
                            rules: [
                                {
                                    required: true,
                                    pattern: /^\w{8}-\w{4}-\w{4}-\w{4}-\w{12}$/,
                                    message: __("Please provide a valid UUID!")
                                }
                            ],
                            children: /*#__PURE__*/ _jsx(Input, {})
                        })
                }),
                /*#__PURE__*/ _jsx(Form.Item, {
                    children: /*#__PURE__*/ _jsx("input", {
                        type: "submit",
                        className: "button button-primary",
                        style: {
                            marginTop: 10
                        },
                        value: __("Download CSV")
                    })
                }),
                showSizeHint && /*#__PURE__*/ _jsx("div", {
                    className: "notice notice-info inline below-h2 notice-alt",
                    style: {
                        margin: "10px 0 0 0"
                    },
                    children: /*#__PURE__*/ _jsx("p", {
                        children: __("The CSV file can be very large because data in this format is redundant per line. In your WordPress database the consents are much smaller.")
                    })
                })
            ]
        })
    });
});
export { ExportConsentsForm };
